import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../shared/components/RouteError";
import { RoutePending } from "../shared/components/RoutePending";

/**
 * @purpose Read the privacy policy
 * @primary Policy text
 * @persona all
 */
export const Route = createFileRoute("/_public/privacy")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
